import { OnboardingLayout } from "@bcc/components/onboarding-layout";
import { MapProductsStep } from "@bcc/components/onboarding/map-products-step";

export function OnboardingMapProductsPage() {
  return (
    <OnboardingLayout contentWidth="wide">
      <MapProductsStep />
    </OnboardingLayout>
  );
}
